// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import { useNavigate } from 'react-router-dom';
import CreateCustomer from "./CreateCustomer";
import { Link } from "react-router-dom";
import CustomerService from "../../../Customer/Controller/CustomerController";
import { handleSubmit as CustomerDiscountSubmit } from "../../../Customer/Controller/CreateCustomerDiscountController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
function CustomerSelectionModal({ show, onClose, CategoryID }) {
    const navigate = useNavigate();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [errors, setErrors] = useState({});
    const [customerList, setCustomerList] = useState([]);
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [AllCustomerList, setCustomerData] = useState([]);
    const [stockCategoryList, setStockCategories] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const tableRef = useRef();
    const fetchCustomers = async (CategoryID) => {
        try {
            const data = await StockDiscountCategoryService.GetAllCustomerByCategoryID(CategoryID)
            setCustomerList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    useEffect(() => {
        fetchCustomers(CategoryID);
        fetchDiscount();
        fetchCustomerList(CategoryID);
    }, [CategoryID]);

    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const fetchCustomerList = async (CategoryID) => {
        try {
            const customerData = await CustomerService.GetAllCustomerForStockCategory(CategoryID);
            setCustomerData(customerData);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const handleDeleteCustomerClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CustomerDiscountService.DeleteCustomerDiscount(ID, redirectCallback);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                    fetchCustomers(CategoryID);
                    fetchCustomerList(CategoryID);

                } catch (error) {
                    console.error('Error deleting Contact:', error);
                }
            }
        })
    };
    const handleCreateCustomerClick = () => {
        setCurrentCustomer(null);
        setIsCustomerModalOpen(true);
    };
    const handleCloseCustomerModal = () => {
        setIsCustomerModalOpen(false);
    };
    const handleCustomerSelect = async (customers, data) => {

        const redirectCallback = () => {
            navigate('/');
        };

        let successCount = 0;
        let alreadyAssignedCount = 0;

        for (const customer of customers) {

            const formData = {
                ID: 0,
                FK_StockCategory_ID: data.FK_StockCategory_ID,
                FK_DiscountType_ID: data.FK_DiscountType_ID,
                FK_ClientCompany_ID: customer.ClientCompanyID,
                dec_Amount: data.dec_Amount
            };

            /*  const listOfDiscounts =
                  await CustomerDiscountService.GetAllCustomerDiscount(
                      redirectCallback,
                      customer.ClientCompanyID
                  );
  
              if (listOfDiscounts.length > 0) {
                  alreadyAssignedCount++;
                  continue;
              }*/

            const postData = await CustomerDiscountSubmit(
                null,
                formData,
                null,
                setErrors
            );

            if (postData.message === "User added successfully") {
                successCount++;
            }
        }

        if (successCount > 0) {
            Swal.fire(
                'Success!',
                `${successCount} customer(s) assigned successfully.${alreadyAssignedCount > 0
                    ? ` ${alreadyAssignedCount} customer(s) were already assigned.`
                    : ''
                }`,
                'success'
            );
        } else {
            Swal.fire(
                'Info',
                'All selected customers already have a discount category assigned.',
                'info'
            );
        }
        fetchCustomers(CategoryID);
        fetchCustomerList(CategoryID);
        handleCloseCustomerModal();
    };

    const handleSubmit = async (event) => {
        try {
            for (const customer of customerList) {
                debugger;
                const formData = {
                    ID: 0,
                    FK_StockCategory_ID: customer.FK_StockCategory_ID,
                    FK_DiscountType_ID: customer.FK_DiscountType_ID,
                    FK_ClientCompany_ID: customer.FK_ClientCompany_ID,
                    dec_Amount: customer.dec_Amount
                };

                const postData = await CustomerDiscountSubmit(
                    event,
                    formData,
                    null,
                    setErrors
                );
            }

            Swal.fire(
                "Success!",
                "Special prices updated successfully.",
                "success"
            );

            fetchCustomers(CategoryID);
            fetchCustomerList(CategoryID);
        } catch (error) {
            console.error(error);

            Swal.fire(
                "Error!",
                "Failed to update special prices.",
                "error"
            );
        }
    };



    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const handleCustomerFieldChange = (e, row) => {
        const { name, value } = e.target;

        setCustomerList(prev =>
            prev.map(item =>
                item.PK_ClientCompanyCategory_ID === row.PK_ClientCompanyCategory_ID
                    ? {
                        ...item,
                        [name]:
                            name === "FK_DiscountType_ID" || name === "dec_Amount"
                                ? Number(value)
                                : value
                    }
                    : item
            )
        );
    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', "marginTop": "50px" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-header" onStart={handleStart}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Assigned Customers</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">

                            <div style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>
                                <div className="col-xl-12">
                                    <Link className='btn btn-primary btn-sm' onClick={handleCreateCustomerClick}>
                                        <i className="icofont-plus" aria-hidden="true">Add New</i>
                                    </Link>
                                </div>
                            </div>

                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Customer Name</th>
                                            <th className="no-wrap">Town/City</th>
                                            <th className="no-wrap">Post Code</th>
                                            <th className="no-wrap">Telephone</th>
                                            
                                            <th className="no-wrap">Account Status</th>
                                            <th className="no-wrap">Account Ref</th>
                                            <th className="no-wrap">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerList.map((customer) => (
                                            <tr key={customer.PK_ClientCompanyCategory_ID}>
                                                <td>{truncateText(customer.CompanyName, 15)}</td>

                                                {/* Discount Type */}
                                                <td className="no-wrap">{truncateText(customer.City)}</td>
                                                <td className="no-wrap">{truncateText(customer.Postcode)}</td>
                                                <td className="no-wrap">{truncateText(customer.Phone1)}</td>
                                                
                                                <td className="no-wrap">{truncateText(customer.vc_AccountStatus)}</td>
                                                <td className="no-wrap">{truncateText(customer.AccountRef)}</td>
                                                <td style={{ textAlign: "right" }}>
                                                    {/* Save Button */}


                                                    {/* Delete Button */}
                                                    <button
                                                        className="text-danger"
                                                        style={{ background: "none", border: "none" }}
                                                        onClick={() =>
                                                            handleDeleteCustomerClick(customer.PK_ClientCompanyCategory_ID)
                                                        }
                                                    >
                                                        <i className="icofont-ui-delete"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            
                            <button
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                             <i className="icofont-close" aria-hidden="true"> Close</i>
                            </button>


                        </div>
                    </div>
                </Draggable>
                {isCustomerModalOpen && (
                    <CreateCustomer
                        show={isCustomerModalOpen}
                        onClose={handleCloseCustomerModal}
                        customers={AllCustomerList}
                        onSelectCustomer={handleCustomerSelect}
                        stockCategoryList={stockCategoryList}
                        DiscountsList={DiscountsList}
                        CategoryID={CategoryID}
                    />
                )}
            </div>

        </div>
    );
}

export default CustomerSelectionModal;
